<template>
	<!-- Default layout (for authentication & error pages) -->
	<div>
		<div class="account-pages mt-5 mb-5">
			<div class="container">
				<slot />
			</div>
		</div>
		<footer class="footer footer-alt">
			<!-- For testing i18n: -->
			<b-dropdown dropup variant="link" size="lg" no-caret>
				<template #button-content>
					<i
						v-b-popover.hover.right="
							$t('PORTAL.Home.popover_change_language')
						"
						class="mdi mdi-translate noti-icon"
					/>
				</template>
				<b-dropdown-item
					v-for="locale in config.locales"
					:key="locale.id"
					href="#"
					:active="config.locale === locale.id"
					@click="changeLanguage(locale.id)"
				>
					{{ locale.translations[0].value }} ({{
						locale.translations[0].locale.split('-')[1]
					}})
				</b-dropdown-item>
			</b-dropdown>
			<br />
			{{ appEnv === 'prod' ? '' : appEnv.toUpperCase() }}
			<br />
			{{ new Date().getFullYear() }} © Lalamove+
		</footer>
	</div>
</template>

<script>
import { configMethods } from '@/store/helpers'

const { VUE_APP_ENV } = process.env

export default {
	data() {
		return {
			config: this.$store ? this.$store.state.config : {} || {},
			appEnv: VUE_APP_ENV
		}
	},
	created: () => {
		document.body.classList.add('authentication-bg')
	},
	methods: {
		...configMethods,
		// Changes language.
		changeLanguage(newLocale) {
			this.changeLocale({ newLocale })
		}
	}
}
</script>
